import { render, staticRenderFns } from "./productitems.vue?vue&type=template&id=5aeb4f82&scoped=true"
import script from "./productitems.vue?vue&type=script&lang=js"
export * from "./productitems.vue?vue&type=script&lang=js"
import style0 from "./productitems.vue?vue&type=style&index=0&id=5aeb4f82&prod&scoped=true&lang=css"
import style1 from "./productitems.vue?vue&type=style&index=1&id=5aeb4f82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb4f82",
  null
  
)

export default component.exports